import { Button, Card } from "@/components/ui";
import type { ContractIntelligenceEditDiff } from "@/types/contractIntelligence.types";

interface ContractIntelligenceDiffCardProps {
  diff: ContractIntelligenceEditDiff;
  onAccept?: () => void;
  onReject?: () => void;
}

export function ContractIntelligenceDiffCard({
  diff,
  onAccept,
  onReject,
}: ContractIntelligenceDiffCardProps) {
  return (
    <Card className="mt-2 gap-0 overflow-hidden py-0">
      <div className="flex items-center gap-2 border-b border-border bg-muted/30 px-3 py-2">
        <span className="font-mono text-[10.5px] font-semibold text-primary">{diff.section}</span>
        <span className="text-[11px] text-muted-foreground">{diff.title}</span>
        <span className="ml-auto rounded bg-success/15 px-1.5 py-0.5 text-[10px] font-medium text-success">
          Pending
        </span>
      </div>
      <div className="space-y-1 px-3 py-2 font-mono text-[11px] leading-relaxed">
        <div className="rounded bg-destructive/10 px-1.5 py-1 text-destructive/90 line-through decoration-destructive/60">
          – {diff.before}
        </div>
        <div className="rounded bg-success/10 px-1.5 py-1 text-success">+ {diff.after}</div>
      </div>
      <div className="flex gap-1.5 border-t border-border px-3 py-2">
        <Button type="button" size="sm" className="h-8 flex-1 text-xs" onClick={onAccept}>
          Accept edit
        </Button>
        <Button type="button" variant="outline" size="sm" className="h-8 text-xs">
          Refine
        </Button>
        <Button type="button" variant="ghost" size="sm" className="h-8 text-xs" onClick={onReject}>
          Reject
        </Button>
      </div>
    </Card>
  );
}
